(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/voucher-redeem/assets/javascripts/voucher-redeem.js') >= 0) return;  svs.modules.push('/components/tur/voucher-redeem/assets/javascripts/voucher-redeem.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect;
const _svs$ui = svs.ui,
  Icon = _svs$ui.ReactIcon,
  Button = _svs$ui.ReactButton;
const _svs$ui$reactForm = svs.ui.reactForm,
  Form = _svs$ui$reactForm.Form,
  ControlGroup = _svs$ui$reactForm.ControlGroup;
const TextInput = svs.ui.reactFormInputs.TextInput;
const _svs$tur$voucherRedee = svs.tur.voucherRedeem.utils,
  validators = _svs$tur$voucherRedee.validators,
  formattedVoucherCode = _svs$tur$voucherRedee.formattedVoucherCode,
  errorMessages = _svs$tur$voucherRedee.errorMessages;
const logger = new svs.core.log.Logger('tur:voucher-redeem');
const VoucherRedeem = _ref => {
  let voucherId = _ref.voucherId,
    onCancel = _ref.onCancel,
    onSuccess = _ref.onSuccess,
    error = _ref.error,
    _ref$shouldFetch = _ref.shouldFetch,
    shouldFetch = _ref$shouldFetch === void 0 ? false : _ref$shouldFetch;
  const _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    invalidVoucher = _useState2[0],
    setInvalidVoucher = _useState2[1];
  const _useState3 = useState(voucherId || ''),
    _useState4 = _slicedToArray(_useState3, 2),
    redeemCode = _useState4[0],
    setRedeemCode = _useState4[1];
  useEffect(() => {
    error && setInvalidVoucher({
      voucherCode: errorMessages.INVALID_VOUCHER
    });
  }, [error]);
  const handleInputChange = e => {
    let val = e.target.value;
    if (val.length === 16) {
      val = val.substring(0, val.length - 1);
    }
    setRedeemCode(val);
  };
  const handleRedeem = async function () {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let formData = arguments.length > 1 ? arguments[1] : undefined;
    e && e.preventDefault();
    if (_.values(formData).some(_ref2 => {
      let isValid = _ref2.isValid;
      return !isValid;
    })) {
      return;
    }
    const voucherCode = redeemCode.replace(/\s/g, '');
    if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      const url = new URL(window.location);
      url.searchParams.set('voucherCode', voucherCode);
      window.history.pushState(null, '', url.toString());
      return svs.components.customer_login.login();
    }
    try {
      var _svs$ui$loader, _svs$ui$loader2;
      (_svs$ui$loader = svs.ui.loader) === null || _svs$ui$loader === void 0 || _svs$ui$loader.show();
      logger.debug('Fetching voucher data..');
      const voucherId = voucherCode.toUpperCase();
      shouldFetch && (await svs.tur.apiCaller.ticketgames.getVoucherById({
        voucherId
      }));
      logger.debug('Successfully retrieved voucher data');
      (_svs$ui$loader2 = svs.ui.loader) === null || _svs$ui$loader2 === void 0 || _svs$ui$loader2.hide();
      onSuccess && onSuccess(voucherCode);
    } catch (e) {
      logger.debug("Failed to retrieve voucher data ".concat(JSON.stringify(e)));
      if (e.code === '26 102' || e.code === '26 3') {
        setInvalidVoucher({
          voucherCode: errorMessages.INVALID_VOUCHER
        });
      } else {
        svs.tur.apierrors.showErrorMessage({
          response: e.code
        });
      }
    }
    svs.ui.loader.hide();
  };
  return React.createElement(Form, {
    onSubmit: handleRedeem,
    setError: invalidVoucher
  }, React.createElement("div", {
    className: "u-flex u-flex-row align-center"
  }, React.createElement("div", {
    className: "f-body f-left"
  }, React.createElement("h2", {
    className: "h2 margin-bottom-2 align-center"
  }, "L\xF6s in v\xE4rdekoder och presentkoder"), React.createElement("p", {
    className: "p"
  }, "H\xE4r kan du l\xF6sa in b\xE5de v\xE4rdekoder du f\xE5tt n\xE4r du r\xE4ttat dina fysiska lotter online och  presenkoder du f\xE5tt i g\xE5va. Koderna l\xF6ses in mot digitala lotter."), React.createElement("p", {
    className: "p"
  }, "Koderna \xE4r tolv tecken l\xE5nga och kan inneh\xE5lla b\xE5de bokst\xE4ver och siffror."), React.createElement("div", {
    className: "margin-bottom-2"
  }, React.createElement(ControlGroup, {
    v2: true
  }, React.createElement(TextInput, {
    label: "Ange din kod h\xE4r (12 tecken)",
    min: 1,
    name: "voucherCode",
    onChange: handleInputChange,
    validateFn: validators,
    value: formattedVoucherCode(redeemCode)
  }))), React.createElement("div", {
    className: "u-flex u-flex-align-items-center margin-bottom-1"
  }, React.createElement(Icon, {
    className: "padding-right-1",
    icon: "tips"
  }), React.createElement("span", null, "Oinl\xF6sta lotter du f\xE5tt via SMS eller e-post l\xF6ser du in enklast via l\xE4nken i ditt SMS eller e-post.")))), React.createElement("div", null, React.createElement(Button, {
    block: true,
    className: "margin-bottom-1",
    focus: true,
    type: "submit"
  }, "Forts\xE4tt"), onCancel && React.createElement(Button, {
    block: true,
    onClick: onCancel,
    transparent: true
  }, "Avbryt")));
};
setGlobal('svs.tur.VoucherRedeem', VoucherRedeem);

 })(window);